import React, { createContext, useEffect, useState, useContext } from "react";

const defaultContextValue = {
  actualCountryCode: null,
  userPhoneExt: null,
  setUserPhoneExt: () => {},
  setCountryCode: () => {},
};

const CountryContext = createContext(defaultContextValue);

export const useCountry = () => useContext(CountryContext);

export const CountryContextProvider = ({ children }) => {
  const [countryCode, setCountryCode] = useState(null);
  const [userPhoneExt, setUserPhoneExt] = useState(countryCode);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ccParam = params.get("country")?.toUpperCase();
    const hostname = window.location.hostname;
    const endsWithBe = hostname.endsWith('.be');


    if ((ccParam === "FR" || ccParam === "BE") && !endsWithBe) {
      setCountryCode(ccParam);
    } 

    if (endsWithBe) {
      setCountryCode('BE');
    }
    
  }, []);

  useEffect(() => {
    setUserPhoneExt(countryCode);
  }, [countryCode]);

  const providerValue = {
    actualCountryCode: countryCode,
    userPhoneExt: userPhoneExt,
    setUserPhoneExt: setUserPhoneExt,
    setCountryCode: setCountryCode,
  };

  return (
    <CountryContext.Provider value={providerValue}>
      {children}
    </CountryContext.Provider>
  );
};